// Lector de CSV para la carga manual. split(",") corría las columnas con
// descripciones entre comillas ("ZAPATO, NEGRO") y no leía el ";" de Excel
// en español. Respeta comillas (RFC 4180) y detecta el separador.

function separador(texto) {
  const primera = texto.split(/\r?\n/, 1)[0];
  const contar = c => primera.split(c).length;
  return contar(";") > contar(",") ? ";" : ",";
}

export function parseCSV(texto) {
  texto = texto.replace(/^﻿/, "");
  const sep = separador(texto);
  const filas = [];
  let fila = [], campo = "", comillas = false;
  for (let i = 0; i < texto.length; i++) {
    const c = texto[i];
    if (comillas) {
      if (c === '"' && texto[i + 1] === '"') { campo += '"'; i++; }
      else if (c === '"') comillas = false;
      else campo += c;
    } else if (c === '"') comillas = true;
    else if (c === sep) { fila.push(campo); campo = ""; }
    else if (c === "\n" || c === "\r") {
      if (c === "\r" && texto[i + 1] === "\n") i++;
      fila.push(campo); filas.push(fila); fila = []; campo = "";
    } else campo += c;
  }
  if (campo !== "" || fila.length) { fila.push(campo); filas.push(fila); }

  const utiles = filas.filter(f => f.some(v => v.trim() !== ""));
  if (utiles.length === 0) return { headers: [], records: [] };
  const headers = utiles[0].map(h => h.trim());
  const records = utiles.slice(1).map(vals => {
    const obj = {};
    headers.forEach((h, i) => { obj[h] = vals[i]?.trim(); });
    return obj;
  });
  return { headers, records };
}
